export default __webpack_public_path__ + "static/scholarship-5b9a9617f67bd964745ee87631e2a53d.png";